































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-const */

import {
  Component, Vue,
} from 'vue-property-decorator';

import InformationIcon from 'mdi-vue/InformationOutline';
import SuccessUploadIcon from '@/assets/upload-data/success.svg';
import FailedUploadIcon from '@/assets/upload-data/failed.svg';
import OnProccessUploadIcon from '@/assets/upload-data/on-process.svg';
import DropdownDownIcon from '@/assets/dropdown-down.svg';
import DropdownUpIcon from '@/assets/dropdown-up.svg';
import ExtensionFileIcon from '@/pages/TopUp/UploadDataBank/components/ExtensionFile.vue';
import ChevronIcon from 'mdi-vue/ChevronRight';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Header from '@/components/Table/Header.vue';
import Row from '@/components/Table/Row.vue';
import Cell from '@/components/Table/Cell.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Modal from '@/components/Modal.vue';
import Accordion from '@/components/Accordion.vue';

import { api2 } from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    OnProccessUploadIcon,
    SuccessUploadIcon,
    FailedUploadIcon,
    LayoutContent,
    Button,
    Table,
    TableBody,
    Header,
    Row,
    Cell,
    ScrollbarWrapper,
    InformationIcon,
    Modal,
    ExtensionFileIcon,
    DropdownDownIcon,
    DropdownUpIcon,
    ChevronIcon,
    Accordion,
  },
})

export default class UploadData extends Vue {
  $refs!: {
    'file-input': HTMLInputElement;
  }

  getBalance!: () => void;
  format!: (value: string | number) => string;

  file: File | null = null;
  data: { name: string; alias: string }[] = [];
  filename = '';
  realname = '';
  rowsData: any[] = [];

  progress = 0;
  hide = true;
  isOnProcess = false;
  isComplete = false;
  token = '';

  openFileInput() {
    this.$refs['file-input'].click();
  }

  extType(file: File | null): string {
    if (file === null) {
      return '';
    }
    const result = file.name.split('.').pop();
    return (typeof result !== 'undefined' ? result : '').toUpperCase();
  }

  async onFileDrag(event: DragEventInit) {
    if (!event.dataTransfer) return;
    const [file] = event.dataTransfer.files;
    this.file = file;
    this.process();
  }

  async onFileInput(event: Event) {
    this.file = null;
    const target = event.target as HTMLInputElement;
    const { files } = target;

    if (files === null || files.length === 0) return;
    const file = files[0];
    this.file = file;
    this.process();
  }

  async process() {
    try {
      const form = new FormData();
      if (this.file !== null) {
        form.append('file', this.file);
      }
      const { data } = await api2.post('/upload-file', form, {
        headers: {
          'Content-Type': 'multipart/form-data;boundary=<calculated when request is sent>',
          token: `bearer ${this.token}`,
        },
        onUploadProgress: (progressEvent) => {
          this.progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          if (this.progress === 100) {
            this.isOnProcess = false;
            this.isComplete = true;
          }
        },
      });
      // this.filename = data?.file_name || '';
      this.filename = data.files[0].filename || '';
      this.realname = data.files[0].realname || '';
      // console.log(this.filename);
      const result = await this.validate();
      // const result = await this.reconcCheck();
      if (result) {
        showToast(ToastType.SUCCESS, 'Congratulations', 'Your data has been successfully uploaded');
      }

      // if (result.error !== null) {
      //   this.progress = 0;
      //   this.isOnProcess = false;
      //   this.isComplete = false;
      //   if (Array.isArray(result.error)) {
      //     this.rowsData = result.error;
      //   } else {
      //     // showToast(ToastType.FAILED, 'Oops… Sorry', result.error || 'Error when processing the upload data');
      //   }
      // } else {
      //   showToast(ToastType.SUCCESS, 'Congratulations', 'Your data has been successfully uploaded');
      // }
    } catch (err) {
      console.error(err);
      this.progress = 0;
      this.isComplete = false;
      showToast(ToastType.FAILED, 'Error', 'Error when processing the upload data');
    }
  }

  eventShowModal() {
    this.$emit('show-modal', {
      data: this.rowsData,
    });
  }

  mounted() {
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
  }

  async validate() {
    let result: any = null;
    try {
      const form = {
        filename: this.filename,
        realname: this.realname,
      };
      const { data, status } = await api2.post('/recon/file/validate', form, {
        headers: {
          token: `bearer ${this.token}`,
        },
      });
      if (status !== 204) {
        result = data;
        if (result.error === 'File within date is exists') {
          showToast(ToastType.FAILED, 'Oops… Sorry', result.error || 'File within date is exists');
          return false;
        }

        if (result.length > 0) {
          this.progress = 0;
          this.isOnProcess = false;
          this.isComplete = false;
          this.rowsData = result;
          showToast(ToastType.FAILED, 'Oops… Sorry', result.error || 'Error when processing the upload data');
          return false;
        }
      }

      return true;
    } catch (err) {
      if (err.response.status === 499) {
        this.progress = 0;
        this.isOnProcess = false;
        this.isComplete = false;
        this.rowsData = err.response.data.additional_information;
      }
      showToast(ToastType.FAILED, 'Oops… Sorry', result.error || 'Error when processing the upload data');
      console.error(err);
      return false;
    }
  }
}
